module.exports = __webpack_public_path__ + "audio-69f315aea746.m4a";